import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, DialogBackdrop, DialogDescription, DialogPanel, DialogTitle } from "@headlessui/react";
import { AlertTriangle, X } from "lucide-react";
import { LicenseGenerateForm } from "./LicenseGenerateForm";
export function LicenseModal({ contractId, isOpen, mode, onClose }) {
    const isReplacing = mode === "regenerate";
    return /*#__PURE__*/ _jsxs(Dialog, {
        open: isOpen,
        onClose: onClose,
        className: "relative z-50",
        children: [
            /*#__PURE__*/ _jsx(DialogBackdrop, {
                className: "fixed inset-0 bg-gray-950/40"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "fixed inset-0 overflow-y-auto p-4 sm:p-6",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "flex min-h-full items-center justify-center",
                    children: /*#__PURE__*/ _jsxs(DialogPanel, {
                        className: "w-full max-w-2xl overflow-hidden rounded-xl bg-white shadow-2xl",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-start justify-between gap-6 border-b border-gray-100 px-6 py-5",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        children: [
                                            /*#__PURE__*/ _jsx(DialogTitle, {
                                                className: "text-lg font-semibold text-gray-900",
                                                children: isReplacing ? "Replace active license" : "Generate license"
                                            }),
                                            /*#__PURE__*/ _jsx(DialogDescription, {
                                                className: "mt-1 text-sm text-gray-500",
                                                children: "Enter the license anchor from every appliance covered by this license."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("button", {
                                        type: "button",
                                        onClick: onClose,
                                        className: "-mr-2 rounded-md p-2 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "sr-only",
                                                children: "Close"
                                            }),
                                            /*#__PURE__*/ _jsx(X, {
                                                className: "h-5 w-5"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "px-6 py-5",
                                children: [
                                    isReplacing && /*#__PURE__*/ _jsxs("div", {
                                        className: "mb-5 flex gap-3 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900",
                                        children: [
                                            /*#__PURE__*/ _jsx(AlertTriangle, {
                                                className: "mt-0.5 h-4 w-4 shrink-0 text-amber-600"
                                            }),
                                            /*#__PURE__*/ _jsx("p", {
                                                children: "The current active license will be superseded as soon as the replacement is generated."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(LicenseGenerateForm, {
                                        contractId: contractId,
                                        mode: mode,
                                        submitLabel: isReplacing ? "Replace license" : "Generate license",
                                        pendingLabel: isReplacing ? "Replacing..." : "Generating...",
                                        successMessage: isReplacing ? "License replaced successfully" : "License generated successfully",
                                        onCancel: onClose,
                                        onSuccess: onClose
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}
